import { render } from "./InitLoader.vue?vue&type=template&id=88827b9c&scoped=true"
import script from "./InitLoader.vue?vue&type=script&lang=js"
export * from "./InitLoader.vue?vue&type=script&lang=js"

import "./InitLoader.vue?vue&type=style&index=0&id=88827b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88827b9c"]])

export default __exports__